angular.module('rjmNg.common.services').factory "rjpopover", [
  "$timeout"
  ($timeout) ->
    rjpopoverGroup = { }
    rjpopoverGroup["global"] = []

    globalId = 0

    getglobalId: () ->
      return globalId += 1

    addToGroup: (popover, group) ->
      group = if group? then group else "global"
      rjpopoverGroup[group] ?= []
      rjpopoverGroup[group].push(popover)
      return

    removeFromGroupById: (group, id) ->
      matchGroup = rjpopoverGroup[group]
      return unless matchGroup?.length > 0
      for i in [0...matchGroup.length]
        if matchGroup[i].id is id
          matchGroup.splice(i, 1)
          break
      return

    hideGroup: (group, id) ->
      matchGroup = rjpopoverGroup[group]
      return unless matchGroup?.length > 0
      for popover in matchGroup
        # do not hide popover with popover.id == id
        if popover.id isnt id
          popover.hide(true)

    showOrHideByIndex: (group, index, visibility) ->
      matchGroup = rjpopoverGroup[group]
      return unless matchGroup?.length > 0
      for popover in matchGroup
        if popover.index is (index).toString()
           switch visibility
             when true then popover.show()
             when false then popover.hide()
      return

    updateGroupLocation: (group) ->
      matchGroup = rjpopoverGroup[group]
      return unless matchGroup?.length > 0
      $timeout () ->
        for popover in matchGroup
          popover.locate()

    getGroup: (group = 'global') ->
      if rjpopoverGroup[group]? then return rjpopoverGroup[group]
      else return null

    getRjpopoverTopLeft: (targetSize, bodySize, rjpopoverSize, position, alignment, corner) ->
      # Try to fit element into the body
      if alignment is "auto"

        if position in ["right", "left"]
          # Try fit alignment TOP, check if bottom of the rjpopover is not outside the body
          if bodySize.height - (targetSize.topDom + rjpopoverSize.height) > 0
             alignment = "top"
          # Try fit alignment CENTER, check if bottom or top of the rjpopover is not outside the body
          else if bodySize.height - Math.round(targetSize.topDom + targetSize.height/2 + rjpopoverSize.height/2) > 0 and targetSize.topDom + Math.round(targetSize.height/2 - rjpopoverSize.height/2) > 0
            alignment = "center"
          # Try fit alignment BOTTOM, check if top of the rjpopover is not outside the body
          else if targetSize.topDom + targetSize.height - rjpopoverSize.height > 0
            alignment = "bottom"
          # Rjpopover to big for thet body element so use as default alignment TOP
          else
            alignment = "top"

        else if position in ["top", "bottom"]
          # Try fit alignment LEFT, check if right of the rjpopover is not outside the body
          if bodySize.width - (targetSize.leftDom + rjpopoverSize.width) > 0
            alignment = "left"
          # Try fit alignment CENTER, check if right or left of the rjpopover is not outside the body
          else if bodySize.width - Math.round(targetSize.leftDom + targetSize.width/2 + rjpopoverSize.width/2) > 0 and targetSize.leftDom + Math.round(targetSize.width/2 - rjpopoverSize.width/2) > 0
            alignment = "center"
          # Try fit alignment RIGHT, check if left of the rjpopover is not outside the body
          else if targetSize.leftDom + targetSize.width - rjpopoverSize.width > 0
            alignment = "right"
          # Rjpopover to big for thet body element so use as default alignment LEFT
          else
            alignment = "left"

      # Set up position top
      if position in ["right", "left"]
        switch alignment
          when "top"
            top = targetSize.top
          when "center"
            top = Math.round(targetSize.top + targetSize.height/2 - rjpopoverSize.height/2)
          when "bottom"
            top = targetSize.top + targetSize.height - rjpopoverSize.height
      else if position is "top"
        top = targetSize.top - rjpopoverSize.height
      else if position is "bottom"
        top = targetSize.top + targetSize.height

      # Set up position left
      if position is "right"
        left = targetSize.left + targetSize.width
      else if position is "left"
        left = targetSize.left - rjpopoverSize.width
      else if position in ["bottom", "top"]
        if corner is "corner"
          switch alignment
            when "right"
              left = targetSize.left + targetSize.width
            when "left"
              left = targetSize.left - rjpopoverSize.width
        else
          switch alignment
            when "right"
              left = targetSize.left + targetSize.width - rjpopoverSize.width
            when "center"
              left = Math.round(targetSize.left + targetSize.width/2 - rjpopoverSize.width/2)
            when "left"
              left = targetSize.left

      return [top, left]

]